/**
 * Currency display utilities
 * Maps ISO currency codes to display symbols for UI rendering
 */

const CURRENCY_SYMBOLS: Record<string, string> = {
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  EUR: "€",
  GBP: "£",
  USD: "$",
  JPY: "¥",
  CAD: "$",
};

/**
 * Converts ISO currency code to display symbol
 * @param currency - ISO currency code (e.g., "SEK", "NOK", "DKK")
 * @returns Display symbol (e.g., "kr") or the original code if not mapped
 */
export function getCurrencySymbol(currency: string): string {
  if (!currency || currency.trim() === "") {
    return ""; // Return empty string for loading states
  }
  return CURRENCY_SYMBOLS[currency] || currency;
}
